import api from './api';

export interface TimelineItem {
  id: string;
  data: string;
  horaInicio: string;
  horaFim: string;
  descricao: string;
  createdAt: string;
  user: {
    id: string;
    name: string;
  };
  anexos: Array<{
    id: string;
    filename: string;
    mimetype: string;
    size: number;
    createdAt: string;
  }>;
}

export interface TicketTimeline {
  ticket: {
    id: string;
    codigo: string;
    titulo: string;
    status: string;
  };
  timeline: TimelineItem[];
}

export const clientTimelineService = {
  /**
   * Busca timeline de um ticket (apenas apontamentos visíveis ao cliente)
   */
  async getTimeline(ticketId: string): Promise<TicketTimeline> {
    const response = await api.get(`/client/tickets/${ticketId}/timeline`);
    return response.data;
  },

  /**
   * Cliente adiciona uma resposta ao ticket
   */
  async addResponse(ticketId: string, mensagem: string): Promise<{ message: string; ticketStatus: string; apontamento?: { id: string } }> {
    const response = await api.post(`/client/tickets/${ticketId}/responses`, {
      mensagem,
    });
    return response.data;
  },
};